import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

const dropdownModule = BsDropdownModule as unknown as {
  forRoot?: () => typeof BsDropdownModule;
};

if (typeof dropdownModule.forRoot !== 'function') {
  dropdownModule.forRoot = () => BsDropdownModule;
}
